// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__141bx","newExpiryDate":"styles_newExpiryDate__Nl3sO","footer":"styles_footer__37dPv"};